import {
  isThreadCategory,
  THREAD_CATEGORY_NAMES,
  type ThreadCategory,
} from "@moderation-contract/thread-classification";
import type { ThreadTag } from "@/entities/thread/types";

export { isThreadCategory, THREAD_CATEGORY_NAMES, type ThreadCategory };

/** 公開タグから16分類に一致する固定カテゴリを1件だけ取り出す。 */
export function getThreadCategoryTag(
  tags: readonly ThreadTag[],
): (ThreadTag & { name: ThreadCategory; kind: "fixed" }) | undefined {
  const normalizedTags = tags.map((tag) =>
    tag.kind === "fixed" && tag.name === "判定不能"
      ? { ...tag, name: "謎" }
      : tag,
  );
  return normalizedTags.find(
    (tag): tag is ThreadTag & { name: ThreadCategory; kind: "fixed" } =>
      tag.kind === "fixed" && isThreadCategory(tag.name),
  );
}

/** 保存済みタグ名を現行16分類だけに絞り、正本の順序で重複を除く。 */
export function normalizeThreadCategoryNames(value: unknown): ThreadCategory[] {
  if (!Array.isArray(value)) return [];
  const names = new Set(
    value
      .map((name: unknown) => (name === "判定不能" ? "謎" : name))
      .filter(
        (name): name is ThreadCategory =>
          typeof name === "string" && isThreadCategory(name),
      ),
  );
  return THREAD_CATEGORY_NAMES.filter((name) => names.has(name));
}
